import { render, staticRenderFns } from "./ApproveModalOverwriteArticle.vue?vue&type=template&id=d841f696"
import script from "./ApproveModalOverwriteArticle.vue?vue&type=script&lang=js"
export * from "./ApproveModalOverwriteArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports